export default __webpack_public_path__ + "ui/assets/img/info-black-32.svg";